






import Vue from 'vue'
export default Vue.extend({
  head: {
    title: 'ACORN Application Dashboard',
    meta: [
      {
        name: 'description',
        content: 'Online portal for applying to come on ACORN summer camps.',
      },
    ],
  },
})
